import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {MatButtonModule} from '@angular/material/button';
@Component({
    selector: 'dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    styleUrls: ['./dialog-confirm.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DialogConfirmComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
  ) {}

  onYesClick(): void {
    this.dialogRef.close(true); // Close dialog and return `true` for Yes
  }

  onNoClick(): void {
    this.dialogRef.close(false); // Close dialog and return `false` for No
  }
}